import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import LeftMenu from '../components/selling/LeftMenu';
import Feature from '../components/selling/Feature';
import ContactUs from '../components/ContactUs';
import SellYourMachineIn30Days from '../components/SellYourMachineIn30Days';

const DetailedExpertReport = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('selling'),
      url: '/content/selling/auction-process',
    },
    {
      label: 'Detaylı Ekspertiz Raporu',
      url: '/content/selling/detailed-expert-report',
    },
  ];

  const items = [
    {
      title: 'Güvenli Satış',
      description: 'iyiMakina.com\'da makina satmak isteyen makina sahipleri adil rekabet ortamı içerisinde güvenle makinalarını satar. Detaylı ekspertiz raporlarımız sayesinde, makinanızı almak isteyen kullanıcılar güvenle fiyat teklifinde bulunur ve makinanız en iyi fiyata satılır.',
      icon: 'fa-solid fa-circle-dollar-to-slot',
    },
    {
      title: 'Görsel ve Video İmkanı',
      description: 'Uzman ekspertiz ekibimiz, makinalarınızın 100’ün üzerinde profesyonel fotoğraflamasını yapar, detaylı videolarını çeker. Makinanızı almak isteyen alıcılar, güvenle makinanızı inceler.',
      icon: 'fa-solid fa-camera',
    },
    {
      title: 'İndirilebilir Ekspertiz Raporu',
      description: 'Makina alıcıları, sunduğumuz eksper raporlarını PDF olarak ücretsiz indirebilir, çıktısını alabilirler. Bu şekilde makinalarınıza tereddütsüz en doğru teklifi yaparlar.',
      icon: 'fa-solid fa-clipboard-check',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <LeftMenu currentPage="detailed-expert-report" />
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">Detaylı Ekspertiz Raporu</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <p>
                  Ekspertiz raporları iki ana kısımdan oluşmaktadır. İlki; satılması planlanan makinanın genellikle Türkiye temsilcisi tarafından yapılan bağımsız ekspertiz incelemesi,
                  ikincisi ise iyiMakina'nın uzman ekibi tarafından kayda alınan genel görünüm, hidrolik, şase kategorilerinde ortalama 100'ün üzerinde fotoğraf ve videoyu kapsayan çalışmadır.
                </p>
                <p>
                  Makinanın Türkiye temsilcisi tarafından yapılan ekspertiz raporu makina sahipleri tarafından yaptırılır.
                  iyiMakina.com’un uzman ekspertiz ekibi, makinanızı bulunduğu yerde ziyaret ederek, kapsamlı ve detaylı görsel ve işitsel malzemelerle destekleyici bir rapor sunar.
                </p>
                <p>
                  Platformumuzda satışa çıkan tüm makinalar, detaylı olarak incelenmiş ekspertiz raporunu içerir. Ekspertiz raporu bulunmayan makinalar, iyiMakina.com'da satışa çıkarılmamaktadır.
                </p>
              </div>
            </div>
            <div className="row mb-30 align-items-stretch">
              {
                _.map(items, (item, index) => (
                  <Feature key={index} data={item} />
                ))
              }
            </div>
            <SellYourMachineIn30Days />
            <ContactUs about="Detaylı Ekpertiz Raporuyla" />
          </div>
        </div>
      </div>
    </main>
  );
};

DetailedExpertReport.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'Detaylı Ekspertiz Raporu',
    },
  };
};

DetailedExpertReport.Layout = Layout;

export default withTranslation('common')(DetailedExpertReport);
